import { cn } from "@omni/utils/styles";

import { ImageLink } from "@/components/General/ImageLink/imageLink";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { Config } from "@/utils/config.utils";
import { DamImage } from "@/utils/dam.utils";

const Image = () => {
    const { t } = useGranite();

    const link = Config["external-links"]["guarantee-notice"];

    if (!link) {
        return null;
    }

    return (
        <ImageLink
            href={link}
            openInNewTab={true}
            alt={t("product.guaranteeNotice.image.alt")}
            src={DamImage.product.guaranteeNotice()}
            lazy={true}
            advisorId={undefined}
            advisorType={undefined}
            advisorMode={undefined}
            renditions={undefined}
            className={cn("tw:border tw:border-black")}
        />
    );
};

export { Image };
